<template>
  <div class="question column is-half">
    <div class="question-content card">
      <div class="card-content" v-html="decodeHtml(question.question[lang])" v-if="isQuotaFull"></div>
    </div>
  </div>
</template>

<script>
import { QuestionMixin } from '@/mixins/question'
import { quotaFullDetail } from '@/api/response'

export default {
  name: 'QuotaFull',
  mixins: [QuestionMixin],
  data () {
    return {
      isQuotaFull: false,
      surveyCode: this.$route.params?.code,
      resultValue: 'N'
    }
  },
  methods: {
    async checkQuotaFull() {
      const targetQuota = this.question?.options?.quota
      const {data: {data: {current: current}}} = await quotaFullDetail(this.surveyCode, this.question?.qid)
      this.$emit("input", { [this.question.qid]: (current >= targetQuota) ? 'Y': 'N' });
      if(current >= targetQuota){
        this.isQuotaFull = true
        this.$emit("quota-full");
      }
      this.$emit('submit')
    }
  },
  async created() {
    await this.$emit("mounted", "is-8");
    await this.checkQuotaFull()
  }
}
</script>
